import { render, staticRenderFns } from "./etapa_5.vue?vue&type=template&id=2bdfb662&scoped=true&"
import script from "./etapa_5.vue?vue&type=script&lang=js&"
export * from "./etapa_5.vue?vue&type=script&lang=js&"
import style0 from "./etapa_5.vue?vue&type=style&index=0&id=2bdfb662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdfb662",
  null
  
)

export default component.exports